import { Component, effect, inject } from '@angular/core';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { ButtonDirective } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { PrimeTemplate } from 'primeng/api';
import { Bookmark } from '../../../models/bookmark';
import { BookmarkStore } from '../../../stores/bookmark/bookmark.state';

@Component({
  selector: 'app-confirm-disable-bookmark-link',
  standalone: true,
  imports: [
    AlertComponent,
    ButtonDirective,
    ConfirmDialogModule,
    DividerModule,
    HeaderComponent,
    PrimeTemplate,
  ],
  templateUrl: './confirm-disable-bookmark-link.component.html',
  styleUrl: './confirm-disable-bookmark-link.component.scss',
})
export class ConfirmDisableBookmarkLinkComponent {
  readonly store = inject(BookmarkStore);
  bookmark: Bookmark | null = null;

  constructor() {
    effect(() => {
      this.bookmark = this.store.selectedItem();
    });
  }

  get title() {
    return `Gast-Link zur Ansicht „${this.bookmark?.title}“ wirklich ${this.bookmark?.guestLink?.enabled ? 'deaktivieren' : 'aktivieren'}?`;
  }
}
